<template>
  <HomePage
    class="w-screen h-screen overflow-hidden mx-auto"
    style="max-width: 580px"
  />
</template>

<script >
import HomePage from "./components/HomePage.vue";

export default {
  name: "App",
  components: {
    HomePage,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
</style>
